import { Field, TextOutput } from 'Components/Core';
import { SectionGroup, Table } from 'Components/Layout';
import { IInterLabActionHistory } from 'Data/ReduxViewModels/InterLab/types';
import { FormatTypes } from 'Lib/Format';

interface IInterLabTransferHistoryTableProps {
  transferHistories: IInterLabActionHistory[];
}

const InterLabTransferHistoryTable: React.FC<IInterLabTransferHistoryTableProps> = ({ transferHistories }) => {
  const OutputField = (value?: any, format?: any) => <Field input={<TextOutput />} value={value} format={format} />;

  return (
    <SectionGroup heading="Transfer History">
      {transferHistories.length === 0 ? (
        <Field input={<TextOutput />} severity="info" value="This work order has not been previously transferred." />
      ) : (
        <Table
          colHeaders={['Date', 'Transferred From', 'Transferred To', 'Transferred By', 'Transfer Notes']}
          colWidths={['75px']}
          alternateRowShading={true}
          data={transferHistories.map((h) => [
            OutputField(h.executedAt, { type: FormatTypes.Date }),
            OutputField(h.originLaboratory),
            OutputField(h.destinationLaboratory),
            OutputField(h.executedBy),
            OutputField(h.transferNotes),
          ])}
        />
      )}
    </SectionGroup>
  );
};

export { InterLabTransferHistoryTable };
